module.exports = __webpack_public_path__ + "img/front_video.f43519f9.png";